import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { StoreThunkDispatch } from 'store/state'
import { LiveArticleData } from 'interfaces'
import { getArticleData } from 'services/content/articles/actions'
import { noop } from 'utils/noop'

interface FetchArticleDataProps {
  url: string
  children?: React.ReactNode
  onFetched(data: LiveArticleData): void
}

const FetchArticleData: React.FC<FetchArticleDataProps> = ({ url, children, onFetched }) => {
  const dispatch = useDispatch<StoreThunkDispatch>()
  // EXPL: keep latest onFetched in a ref so the fetch stays keyed on url/dispatch only —
  // callers pass a non-memoized callback that would otherwise refetch on every render.
  const onFetchedRef = useRef(onFetched)
  useEffect(() => {
    onFetchedRef.current = onFetched
  })

  useEffect(() => {
    const subscription = dispatch(getArticleData(url)).subscribe(data => onFetchedRef.current(data), noop)
    return () => subscription.unsubscribe()
  }, [url, dispatch])

  return children ? <>{children}</> : null
}

export default FetchArticleData
